module.exports = __webpack_public_path__ + "img/grade2.f27fb376.jpg";